<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 fluid scrollable :fullscreen="$vuetify.breakpoint.xsOnly" content-class="round-2xl" persistent)
    v-card
      .pa-8
        .text-xl.font-medium.mb-4 Are you sure you want to remove the reject reason "{{ name }}" ?
        .text-md All of the response will also be deleted. Click "Confirm" to proceed
      v-divider

      v-card-actions.px-6.py-3
        v-btn.button-md.underline.ml-n4(@click="showDialog = false" color="primary" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md.white--text(@click="confirm" color="danger500" depressed :loading="isLoading") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DeleteRejectReasonDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    reason: {
      type: Object,
      default: () => {}
    },
    rejectStatus: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    isLoading: false,
    name: ''
  }),
  mounted () {
    this.name = this.reason.name
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    confirm () {
      this.isLoading = true
      this.$axios.delete(`/connect/${this.company.slug}/statuses/${this.rejectStatus.id}/reasons/${this.reason.id}`)
        .then(() => {
          this.showMessage(['success', 'Reject reason deleted successfully'])
          this.showDialog = false
          this.$emit('deleted')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>